import { render, staticRenderFns } from "./ChangeOwnPassword.vue?vue&type=template&id=c40333bc&"
import script from "./ChangeOwnPassword.vue?vue&type=script&lang=js&"
export * from "./ChangeOwnPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports